module.exports = __webpack_public_path__ + "static/img/tagtop2.3fccc5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tagtop2.png
// module id = Cpoh
// module chunks = 1